export const EVEN_HELPER_EVENT = 'even_parent_data';
export const EVEN_IFRAME_INIT_EVENT = 'even_iframe_initialized';
export const EVEN_SCROLL_EVENT = 'even_parent_scroll';
export const EVEN_URL_APPEND_EVENT = 'even_parent_append_url';
export const EVEN_URL_PARAM_REMOVE_EVENT = 'even_parent_url_param_remove';
export const EVEN_URL_PARAMS_EVENT = 'even_parent_url_params';
// The keys for the corresponding ParentData.
// Note that we only look for keys prefixed with
// even_ or fiona_, so when you see 'results' here
// that means we'll look for even_results or
// fiona_results being passed from the parent.
export var ParentDataKeys;
(function (ParentDataKeys) {
    ParentDataKeys["Offer"] = "offer";
    ParentDataKeys["Referrer"] = "referrer";
    ParentDataKeys["ResultsUuid"] = "results";
    ParentDataKeys["Step"] = "step";
    ParentDataKeys["Url"] = "url";
})(ParentDataKeys || (ParentDataKeys = {}));
export var PublishKey;
(function (PublishKey) {
    PublishKey["ApplicationComplete"] = "appComplete";
    PublishKey["ApplicationLoaded"] = "appLoaded";
    PublishKey["ApplicationStepSelected"] = "applicationStepSelected";
    PublishKey["ClientTagsLoaded"] = "clientTagsLoaded";
    PublishKey["CreditCardOfferClick"] = "creditCardOfferClick";
    PublishKey["DepositsOfferClick"] = "depositsOfferClick";
    PublishKey["Impression"] = "impression";
    PublishKey["LeadInitialized"] = "leadInitialized";
    PublishKey["LeadPreQualifiedOrPreApproved"] = "leadPreQualifiedOrPreApproved";
    PublishKey["LifeInsuranceOfferClick"] = "lifeInsuranceOfferClick";
    PublishKey["LifeInsurancePhoneCallRequested"] = "lifeInsurancePhoneCallRequested";
    PublishKey["LifeInsuranceReportProductSubType"] = "LIFE_INSURANCE_REPORT_PRODUCT_SUB_TYPE";
    PublishKey["LoanOfferAutoRedirect"] = "loanOfferAutoRedirect";
    PublishKey["LoanOfferClick"] = "loanOfferClick";
    PublishKey["PreviewOffersDisplayed"] = "previewOffersRender";
    PublishKey["RateTableDisplayed"] = "ratetableRender";
    PublishKey["RequestRedirect"] = "requestRedirect";
    PublishKey["SpecialOfferClick"] = "specialOfferClick";
    PublishKey["StepSelected"] = "STEP_SELECTED";
})(PublishKey || (PublishKey = {}));
//# sourceMappingURL=messages.js.map